import * as React from "react"

const ConceptSVG = (props) => (
	<svg width={23} height={22} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			d="M20.875 11h1.042M18.27 4.5l1.042-1M11.5 2V1M4.73 4.5l-1.042-1M2.125 11H1.083m8.334 10h4.167m3.125-10a4.85 4.85 0 0 0-.736-2.56 5.122 5.122 0 0 0-1.997-1.838 5.386 5.386 0 0 0-2.696-.596 5.36 5.36 0 0 0-2.633.813A5.07 5.07 0 0 0 6.818 8.81a4.827 4.827 0 0 0 .448 5.103 5.173 5.173 0 0 0 2.15 1.67V18h4.168v-2.416a5.16 5.16 0 0 0 2.274-1.845c.555-.814.85-1.766.85-2.739Z"
			stroke="currentColor"
			strokeWidth={2}
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
)

export default ConceptSVG
